import React, { useState, useEffect } from 'react';
import styles from './styles.scss';
import moment from 'moment';
import Calendar from 'react-calendar';
import { WIDGET_LOCALE } from '../../../../../../../locale-wrapper';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ColorDescription } from '../../ColorDescription';
import { List } from 'immutable';

export const CalendarView = ({ occurrences = List(), setOccurrencesDate, settings, calendarMetadata, calendarLoading, onCalendarMonthChange }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [activeStartDate, setActiveStartDate] = useState(null);

  // Update active month when metadata changes (from API response)
  useEffect(() => {
    if (calendarMetadata) {
      const { month, year } = calendarMetadata;
      // Create date for first day of the month from metadata
      const metadataDate = new Date(year, month - 1, 1); // month is 1-indexed, Date expects 0-indexed
      setActiveStartDate(metadataDate);
    }
  }, [calendarMetadata]);

  const dates = occurrences.toArray().reduce((accum, occurrenceDate) => {
    const timeEntries = occurrenceDate.get('time_entries') || List();
    const tickets = timeEntries.map((record) => record.get('tickets')) || [];
    const status = tickets.toArray().some((ticket) => ticket.first().get('status') === 'onsale');

    return Object.assign(accum, { [moment(occurrenceDate.get('start_date')).format('yyyy-MM-D')]: status });
  }, {});

  const handleOnClick = (value) => {
    setOccurrencesDate(moment(value));
    setSelectedDate(value);
  };

  const handleActiveStartDateChange = ({ activeStartDate: newActiveStartDate }) => {
    if (!newActiveStartDate || !onCalendarMonthChange) return;

    const newMonth = moment(newActiveStartDate).month() + 1; // moment months are 0-indexed
    const newYear = moment(newActiveStartDate).year();

    // Call the handler to load new month data
    onCalendarMonthChange(newMonth, newYear);
  };

  const currentDate = new Date();
  const tileDisabled = ({ date }) => date < new Date(currentDate.setHours(0, 0, 0, 0));

  return (
    <div className={styles.wrapper} style={{ position: 'relative' }}>
      {calendarLoading && (
        <div className={styles.loadingOverlay}>
          <div className={styles.spinner} />
        </div>
      )}
      <Calendar
        locale={WIDGET_LOCALE}
        showNeighboringMonth={false}
        prevLabel={<ChevronLeftIcon />}
        nextLabel={<ChevronRightIcon />}
        minDetail="month"
        value={selectedDate}
        activeStartDate={activeStartDate}
        tileDisabled={tileDisabled}
        onChange={handleOnClick}
        onActiveStartDateChange={handleActiveStartDateChange}
        tileClassName={({ date }) => {
          const dateKey = moment(date).format('yyyy-MM-D');
          if (Object.keys(dates).includes(dateKey)) {
            return dates[dateKey] ? styles.onSaleCell : styles.soldOutCell;
          }
          return null;
        }}
      />
      <ColorDescription settings={settings} />
    </div>
  );
};
